import { render, staticRenderFns } from "./ModifyPassword.vue?vue&type=template&id=2d77ac69&scoped=true"
import script from "./ModifyPassword.vue?vue&type=script&lang=js"
export * from "./ModifyPassword.vue?vue&type=script&lang=js"
import style0 from "./ModifyPassword.vue?vue&type=style&index=0&id=2d77ac69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d77ac69",
  null
  
)

export default component.exports